/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TestProfileIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Test Profile',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M35.338 32.3 23.864 20.824a12.012 12.012 0 1 0-3.04 3.04L32.3 35.338a2.155 2.155 0 0 0 3.04-3.04ZM4 14a10 10 0 1 1 17.8 6.192c-.5-1.344-1.816-2.977-4.956-3.3a.777.777 0 0 1-.673-.78V14.99a.78.78 0 0 1 .2-.5 5.949 5.949 0 0 0 1.353-3.71c0-2.808-1.489-4.377-3.74-4.377S10.2 8.031 10.2 10.777a6.008 6.008 0 0 0 1.417 3.71.779.779 0 0 1 .2.5v1.121a.774.774 0 0 1-.675.781c-3.2.278-4.481 1.9-4.962 3.265A9.91 9.91 0 0 1 4 14Z"
    />
  </svg>`;
};
